import React from 'react'

import { navigateToLink } from '../../../../utils/redirect/navigateToLink'
import { useAnalyticsEvents } from '../../../hooks/useAnalyticsEvents'
import { Image } from '../Image'
import { validateLink } from './validateLink'
import { IS_WEBVIEW } from '../../../constants'

import type { ImageWithAlt } from '../../../types/ClubCard/ClubCardBenefits'

import './shortcut.scss'

export interface ShortcutProps {
  text: string
  icon: ImageWithAlt
  href: string
  location: string
  className?: string
  deepLink?: {
    android: string
    apple: string
  }
  isLoading?: boolean
  openNewTab?: boolean
}

export const Shortcut = ({
  text,
  icon,
  href,
  className = '',
  location,
  deepLink,
  isLoading = false,
  openNewTab = false,
}: ShortcutProps) => {
  const { genericTaggingEvent } = useAnalyticsEvents()

  if (!text || !icon?.src || !href) {
    return null
  }

  const link = validateLink({ deepLink, href })

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event?.preventDefault()

    genericTaggingEvent('header_shortcut', {
      name: text,
      location: location,
    })

    const shouldOpenInNewTab = openNewTab || IS_WEBVIEW

    if (shouldOpenInNewTab) {
      window.open(link, '_blank', 'noopener,noreferrer')
    } else {
      navigateToLink(link)
    }

    // Default redirect if deepLink doesn't work
    setTimeout(() => {
      if (document.hasFocus() && (deepLink?.android || deepLink?.apple)) {
        if (shouldOpenInNewTab) {
          window.open(href, '_blank', 'noopener,noreferrer')
        } else {
          navigateToLink(href)
        }
      }
    }, 1000)
  }

  return (
    <button
      type="button"
      className={`shortcut ${isLoading ? 'loading' : ''} ${className}`}
      onClick={handleClick}
    >
      <div className="shortcut-image">
        <Image alt={icon?.alt} baseUrl={icon?.src} width={32} height={32} />
      </div>
      <p className="shortcut-text">{text}</p>
    </button>
  )
}
